import React from "react";
import { Button } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import type { CSSProperties } from "react";

import { useAppContext } from "@components/AppContext";
import type { AppContext } from "@components/AppContext/types";

const LABEL_COPIED = "Value copied to the clipboard";

const WRAPPER_STYLE: CSSProperties = { position: "relative", height: 18 };
const BUTTON_STYLE: CSSProperties = { marginLeft: -8, marginTop: -3, position: "absolute" };

type Props = {
  value: string;
};

const CopyValueButton = ({ value }: Props): JSX.Element => {
  const { showSuccessMessage } = useAppContext() as AppContext;

  const onClick = (): void => {
    navigator.clipboard.writeText(value);
    showSuccessMessage(LABEL_COPIED);
  };

  return (
    <div style={WRAPPER_STYLE}>
      <Button
        size="small"
        type="text"
        icon={<CopyOutlined />}
        style={BUTTON_STYLE}
        onClick={onClick}
        iconPosition="end"
      >
        {value}
      </Button>
    </div>
  );
};

export default CopyValueButton;
